// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preferred-supplier-button {
  color: var(--ion-color-light-shade);
  font-size: 15px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid var(--ion-color-lighter-light);
  background-color: var(--ion-color-lighter-light);
  color: var(--ion-color-medium);
  line-height: 20px;
  margin-bottom: 4px;
  margin-right: 18px;
  height: 42px;
}
.preferred-supplier-button span {
  line-height: 10px;
  position: relative;
  font-size: 13px;
  top: -5px;
}
.preferred-supplier-button i {
  font-size: 20px;
  margin-left: 6px;
  line-height: 24px;
  position: relative;
  top: -1px;
}
.preferred-supplier-button.active {
  border: 1px solid var(--ion-color-lighter-light);
  background-color: var(--ion-color-lighter-light);
  color: var(--ion-color-secondary-tint);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/wholesale/wholesale-supplier/wholesale-supplier.page.scss"],"names":[],"mappings":"AAAA;EAEC,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gDAAA;EACA,gDAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAAD;AACC;EACC,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;AACF;AACC;EACC,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AACF;AACC;EAEO,gDAAA;EACA,gDAAA;EACA,sCAAA;AAAR","sourcesContent":[".preferred-supplier-button\r\n{\r\n\tcolor: var(--ion-color-light-shade);\r\n\tfont-size: 15px;\r\n\tfont-weight: 500;\r\n\tpadding: 8px 16px;\r\n\tborder-radius: 20px;\r\n\tborder: 1px solid var(--ion-color-lighter-light);\r\n\tbackground-color: var(--ion-color-lighter-light);\r\n\tcolor: var(--ion-color-medium);\r\n\tline-height: 20px;\r\n\tmargin-bottom: 4px;\r\n\tmargin-right: 18px;\r\n\theight: 42px;\r\n\tspan {\r\n\t\tline-height: 10px;\r\n\t\tposition: relative;\r\n\t\tfont-size: 13px;\r\n\t\ttop: -5px;\r\n\t}\r\n\ti {\r\n\t\tfont-size: 20px; \r\n\t\tmargin-left: 6px;\r\n\t\tline-height: 24px;\r\n\t\tposition: relative;\r\n\t\ttop: -1px;\r\n\t}\r\n\t&.active \r\n\t{\r\n        border: 1px solid var(--ion-color-lighter-light);\r\n        background-color: var(--ion-color-lighter-light);\r\n        color: var(--ion-color-secondary-tint);\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
